import cellActivitionCode from './cellActivitionCode'

export default cellActivitionCode